import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export function useNavigateWithLang() {
    const { lang } = useParams();
    const navigate = useNavigate();

    const navigateWithLang = useCallback(
        (url: string, options?: { replace?: boolean; state?: unknown }) =>
            navigate(lang ? `/${lang}${url}` : url, options),
        [lang, navigate]
    );

    return navigateWithLang;
}
